class ProductSignupVariantTracker {
  constructor(block) {
    this.block = block;
    this.section = block.closest('.js-product');
    this.variantInput = block.querySelector('[data-signup-variant]');
    this.variantIdInput = block.querySelector('[data-signup-variant-id]');
    if (!this.section || !this.variantInput || !this.variantIdInput) return;

    this.updateState(this.variantIdInput.value ? {
      id: this.variantIdInput.value,
      title: this.variantInput.value,
      available: block.dataset.available === 'true'
    } : null);
    this.section.addEventListener('on:variant:change', (event) => {
      if (event.target.closest('.js-product') !== this.section) return;
      this.updateState(event.detail.variant);
    });
  }

  updateState(variant) {
    this.variantInput.value = variant?.title || '';
    this.variantIdInput.value = variant?.id || '';
    this.block.hidden = this.block.dataset.unavailableOnly === 'true'
      && (!variant || variant.available);
  }
}

function initializeProductSignups(root = document) {
  root.querySelectorAll('[data-product-signup]').forEach((block) => {
    if (block.dataset.signupInitialized) return;
    block.dataset.signupInitialized = 'true';
    new ProductSignupVariantTracker(block);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeProductSignups());
} else {
  initializeProductSignups();
}
document.addEventListener('shopify:section:load', (event) => initializeProductSignups(event.target));
